var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 1.95321V0.619873M6.00033 1.95321C5.26395 1.95321 4.66699 2.55016 4.66699 3.28654C4.66699 4.02292 5.26395 4.61987 6.00033 4.61987M6.00033 1.95321C6.7367 1.95321 7.33366 2.55016 7.33366 3.28654C7.33366 4.02292 6.7367 4.61987 6.00033 4.61987M2.00033 9.95321C2.73671 9.95321 3.33366 9.35625 3.33366 8.61987C3.33366 7.88349 2.73671 7.28654 2.00033 7.28654M2.00033 9.95321C1.26395 9.95321 0.666992 9.35625 0.666992 8.61987C0.666992 7.88349 1.26395 7.28654 2.00033 7.28654M2.00033 9.95321V11.2865M2.00033 7.28654V0.619873M6.00033 4.61987V11.2865M10.0003 9.95321C10.7367 9.95321 11.3337 9.35625 11.3337 8.61987C11.3337 7.88349 10.7367 7.28654 10.0003 7.28654M10.0003 9.95321C9.26395 9.95321 8.66699 9.35625 8.66699 8.61987C8.66699 7.88349 9.26395 7.28654 10.0003 7.28654M10.0003 9.95321V11.2865M10.0003 7.28654V0.619873",
    stroke: "#8D8F90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDisable);
export default __webpack_public_path__ + "static/media/filterDisable.1b849f88da2cb9359d46ccbe3b976d19.svg";
export { ForwardRef as ReactComponent };